import axios from '../../utils/axiosConfig';
import {
  FOLDER_CREATE_REQUEST,
  FOLDER_CREATE_SUCCESS,
  FOLDER_CREATE_FAIL,
  FOLDER_LIST_REQUEST,
  FOLDER_LIST_SUCCESS,
  FOLDER_LIST_FAIL,
  FOLDER_BY_OWNER_REQUEST,
  FOLDER_BY_OWNER_SUCCESS,
  FOLDER_BY_OWNER_FAIL,
  FOLDER_UPDATE_REQUEST,
  FOLDER_UPDATE_SUCCESS,
  FOLDER_UPDATE_FAIL,
  FOLDER_DELETE_REQUEST,
  FOLDER_DELETE_SUCCESS,
  FOLDER_DELETE_FAIL,
  FOLDER_INITIALIZE_REQUEST,
  FOLDER_INITIALIZE_SUCCESS,
  FOLDER_INITIALIZE_FAIL,
  FOLDER_REORDER_REQUEST,
  FOLDER_REORDER_SUCCESS,
  FOLDER_REORDER_FAIL,
} from '../constants/folderConstants';

// Create a new folder
export const createFolder = (folderData) => async (dispatch) => {
  try {
    dispatch({ type: FOLDER_CREATE_REQUEST });

    const { data } = await axios.post('/api/folders', folderData);

    dispatch({
      type: FOLDER_CREATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: FOLDER_CREATE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Get all folders with document counts
export const getAllFolders = (language = 'en', caseFileId = null) => async (dispatch) => {
  try {
    dispatch({ type: FOLDER_LIST_REQUEST });

    let url = `/api/folders/all?language=${language}`;
    if (caseFileId) {
      url += `&caseFileId=${caseFileId}`;
    }

    const { data } = await axios.get(url);

    dispatch({
      type: FOLDER_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: FOLDER_LIST_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Get folders by owner
export const getFoldersByOwner = (ownerId) => async (dispatch) => {
  try {
    dispatch({ type: FOLDER_BY_OWNER_REQUEST });

    const { data } = await axios.get(`/api/folders/owner/${ownerId}`);

    dispatch({
      type: FOLDER_BY_OWNER_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: FOLDER_BY_OWNER_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Get folders for current user (for DocumentUpload)
export const getMyFolders = (language = 'en', caseFileId = null) => async (dispatch) => {
  try {
    dispatch({ type: FOLDER_BY_OWNER_REQUEST });

    let url = `/api/folders/my-folders?language=${language}`;
    if (caseFileId) {
      url += `&caseFileId=${caseFileId}`;
    }

    const { data } = await axios.get(url);

    dispatch({
      type: FOLDER_BY_OWNER_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: FOLDER_BY_OWNER_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Update folder
export const updateFolder = (folderId, folderData) => async (dispatch) => {
  try {
    dispatch({ type: FOLDER_UPDATE_REQUEST });

    const { data } = await axios.put(`/api/folders/${folderId}`, folderData);

    dispatch({
      type: FOLDER_UPDATE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: FOLDER_UPDATE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Delete folder
export const deleteFolder = (folderId) => async (dispatch) => {
  try {
    dispatch({ type: FOLDER_DELETE_REQUEST });

    await axios.delete(`/api/folders/${folderId}`);

    dispatch({
      type: FOLDER_DELETE_SUCCESS,
      payload: folderId,
    });
  } catch (error) {
    dispatch({
      type: FOLDER_DELETE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Initialize default folders for a user
export const initializeDefaultFolders = (ownerId) => async (dispatch) => {
  try {
    dispatch({ type: FOLDER_INITIALIZE_REQUEST });

    const { data } = await axios.post(`/api/folders/initialize/${ownerId}`);

    dispatch({
      type: FOLDER_INITIALIZE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: FOLDER_INITIALIZE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Initialize 4 default folders for a case file
export const initializeDefaultFoldersForCaseFile = (caseFileId, responsibleLawyerId) => async (dispatch) => {
  try {
    dispatch({ type: FOLDER_INITIALIZE_REQUEST });

    const { data } = await axios.post('/api/folders/initialize-case-folders', {
      caseFileId,
      responsibleLawyerId
    });

    dispatch({
      type: FOLDER_INITIALIZE_SUCCESS,
      payload: data,
    });

    return data; // Return data for chaining in CreateFilePage
  } catch (error) {
    dispatch({
      type: FOLDER_INITIALIZE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
    throw error; // Re-throw for error handling in CreateFilePage
  }
};

// Reorder folders
export const reorderFolders = (folderOrders) => async (dispatch) => {
  try {
    console.log('🚀 Redux Action: Starting folder reorder request');
    console.log('📤 Sending folder orders:', folderOrders);

    await axios.put('/api/folders/reorder', { folderOrders });
    // Do NOT dispatch FOLDER_REORDER_SUCCESS or update Redux state on success
  } catch (error) {
    console.error('❌ Redux Action: Folder reorder failed:', error);
    console.error('❌ Error response:', error.response?.data);

    dispatch({
      type: FOLDER_REORDER_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};
